import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export default function (requestData) {
  return instance(requestData).catch(err => {
    return Promise.reject(err);
  });
}
